"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports.LocationMap = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _gmap = require("@kyruus/gmap");
var _awsMap = require("@kyruus/aws-map");
var _staticMapMachine = require("../../../stateMachine/machines/staticMapMachine");
var _States = require("../../../lib/constants/States");
var _react2 = require("@xstate/react");
var _utils = require("../../../lib/utils");
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const sizes = exports.sizes = {
  small: '500x300',
  medium: '700x300',
  large: '600x300'
};
const LocationMap = _ref => {
  let {
    location,
    providerId,
    track,
    config,
    awsMapConfig
  } = _ref;
  if (config.maps_config?.location_service_provider === 'aws') {
    return /*#__PURE__*/_react.default.createElement(_awsMap.AwsMap, {
      locations: [location],
      awsMapConfig: awsMapConfig
    });
  }
  return /*#__PURE__*/_react.default.createElement(Gmap, {
    location: location,
    providerId: providerId,
    track: track,
    config: config
  });
};
exports.LocationMap = LocationMap;
const Gmap = _ref2 => {
  let {
    location,
    providerId,
    track,
    config
  } = _ref2;
  const machine = (0, _react.useMemo)(() => {
    return (0, _staticMapMachine.createStaticMapMachine)({
      context: {
        providerId: providerId,
        locationId: location.id,
        sizes: [sizes.small, sizes.medium, sizes.large]
      }
    });
  }, [location.id, providerId]);
  const [state] = (0, _react2.useMachine)(machine);
  const {
    context
  } = state;
  const {
    mapUrls
  } = context;
  if (state.matches(_States.error)) {
    return null;
  }
  if (state.matches(_States.loading)) {
    return /*#__PURE__*/_react.default.createElement(_styles.MapLoading, null);
  }
  const formattedLocation = (0, _utils.formatLocation)(location);

  // maps_config.google_routes defaults to true
  // only if it is set to false do we want to suppress google routing
  const shouldLinkToGoogleMaps = config.maps_config?.google_routes === false;
  return /*#__PURE__*/_react.default.createElement(_gmap.StaticGmap, {
    mapLink: shouldLinkToGoogleMaps ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(formattedLocation)}` : null,
    label: formattedLocation,
    smallHeight: "auto",
    smallImage: mapUrls[sizes.small],
    mediumHeight: "auto",
    mediumImage: mapUrls[sizes.medium],
    largeHeight: "auto",
    largeImage: mapUrls[sizes.large],
    onClick: () => {
      track('user_action.direct_book.appointment_confirmation_page.location_map');
    }
  });
};
LocationMap.propTypes = {
  location: _propTypes.object.isRequired,
  providerId: _propTypes.string.isRequired,
  track: _propTypes.func,
  config: _propTypes.object.isRequired,
  awsMapConfig: _propTypes.object
};
LocationMap.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LocationMap",
  "props": {
    "location": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "providerId": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "config": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "awsMapConfig": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};